module.exports = __webpack_public_path__ + "static/media/checkbox_true.6858472a.svg";